
<div class="container" id="pmtReceipt" style="height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100%;">
    <div style="width: 100%;">
            <!--Header-->
            <div style="text-align: center; margin-top: 20px;" *ngIf="prntHeader">
                <img alt="image" style="width: 100%; margin: 0px;"  src="https://biziverse.com/{{prntHeader}}"><br> <br> <br> 
                <span style="font-size: 20px; font-weight: bold;">RECEIPT</span><br>
            </div><br>
           
            <div class="col-md-12 col-sm-12 col-xs-12" *ngIf="prntHeader == ''">
                <div class="col-md-3 col-sm-4 col-xs-4 pad0" style="display: inline-block;">&nbsp;</div>
                    <div class="col-md-6 col-sm-4 col-xs-4 pad0" style="display: inline-block; margin-top: 20px;">
                        
                        <div class="" style="text-align: center;margin-top: 20px;">
                            <span style="font-size:20px;">{{AgencyName}}</span><br>
                            <span style="font-size: 13px;">{{City ? City + ',' : ''}} {{State}}</span><br><br>
                            <span style="font-size: 20px; font-weight: bold;">RECEIPT</span><br>  
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-4 col-xs-4 pad0" style="display: inline-block;">&nbsp;</div>
            </div>
            <!--Table + Webview-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="width: 100%; margin-top: 25px;">
                    <div class="pad0" style="display: inline-block;">
                        <div style="font-size: 18px; display: inline-block;">Received with thanks from M/s. :</div> <span style="font-size: 20px; font-weight: bold; margin-left: 10px;"> {{data.payerPartyName}} </span><br><br>
                        <div style="font-size: 18px; display: inline-block;">The sum of : </div> <span style="font-size: 20px; font-weight: bold; margin-left: 10px;"> {{data.sumAmount | amountInWord}} ({{data.sumAmount | lacFormat}})</span><br><br>
                        <div style="font-size: 18px; display: inline-block;">Date : </div> <span style="font-size: 20px; font-weight: bold; margin-left: 10px;"> {{data.voucherDate}} </span>  <br> <br>
                        <div style="font-size: 18px; display: inline-block;">By : </div> <span style="font-size: 20px; font-weight: bold; margin-left: 10px;"> {{data.voucherType == 'Bank Receipt' ? 'Bank' : 'Cash'}}</span><br><br>
                        <div style="font-size: 18px; display: inline-block;">Notes : </div> <span style="font-size: 20px; font-weight: bold; margin-left: 10px;"> {{data.details ? data.details : '-'}}</span><br><br>
                    </div>
            </div>
            <br><br><br>
            <div class="col-md-12 col-sm-12 col-xs-12 pad0" style="width: 100%; margin-top: 25px;">
                    <div class="" style="padding: 0px; display: inline-block;">
                         <span style="font-size: 18px;"> Authorised Signatory </span>
                    </div> 
            </div>
        </div>
    </div>